import moment from "moment";
import { Button } from "components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "components/ui/select";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "components/ui/hover-card";
import { Service } from "utils/services";
import { useState } from "react";
export function CalendarHeader({ currentView, setCurrentView, currentDate, setCurrentDate, setDirection }: any) {
  // const handlePrev = () => setCurrentDate(moment(currentDate).subtract(1, currentView));
  // const handleNext = () => setCurrentDate(moment(currentDate).add(1, currentView));
  // const handleToday = () => setCurrentDate(moment());

  const handlePrev = () => {
    setDirection("left");
    setCurrentDate((prev: any) => prev.clone().subtract(1, currentView));
  };

  const handleNext = () => {
    setDirection("right");
    setCurrentDate((prev: any) => prev.clone().add(1, currentView));
  };

  const handleToday = () => {
    const diff = currentDate.diff(moment(), "days");
    setDirection(diff > 0 ? "left" : "right");
    setCurrentDate(moment());
  };

  const viewOptions = ["week", "day", "month"];

  return (
    <div className="flex items-center justify-between p-4  bg-gray-300 dark:bg-[#2c3a52]">
      <div className="flex items-center gap-2">
        <Button onClick={handlePrev} variant="outline" className="px-2 py-1 rounded-full text-gray-400 ">
          <ArrowLeft />
        </Button>
        <HoverCard>
          <HoverCardTrigger asChild>
            <span onClick={handleToday} className="px-2 py-1 rounded text-sm bg-none  text-gray-800 dark:text-gray-300 cursor-pointer uppercase">
              {" "}
              Today
            </span>
          </HoverCardTrigger>
          <HoverCardContent className="w-50">
            <div className="flex justify-between gap-4">
              <div className="space-y-1">
                <div className="text-muted-foreground text-xs">{Service.formatDateTime(currentDate, { format: "dddd, DD-MMMM-YYYY" })}</div>
              </div>
            </div>
          </HoverCardContent>
        </HoverCard>

        <Button onClick={handleNext} variant="outline" className="px-2 py-1  rounded-full text-gray-400 ">
          <ArrowRight />
        </Button>
        <h2 className="ml-4 text-lg font-semibold">{currentDate.format(currentView === "month" ? "MMMM YYYY" : "MMM D, YYYY")}</h2>
      </div>

      <div className="flex items-center gap-4">
        <Select value={currentView} onValueChange={(value) => setCurrentView(value as "week" | "day" | "month")}>
          <SelectTrigger className="w-[120px]">
            <SelectValue placeholder="Select View" />
          </SelectTrigger>
          <SelectContent>
            {viewOptions.map((view) => (
              <SelectItem key={view} value={view}>
                {view.charAt(0).toUpperCase() + view.slice(1)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
